// src/app/redux/reducers/paramDomainesThemesReducer.js

import {
    FETCH_DOMAINES_REQUEST, FETCH_DOMAINES_SUCCESS, FETCH_DOMAINES_FAIL,
    FETCH_THEMES_REQUEST, FETCH_THEMES_SUCCESS, FETCH_THEMES_FAIL,
    FETCH_THEMES_BY_DOMAINE_REQUEST, FETCH_THEMES_BY_DOMAINE_SUCCESS, FETCH_THEMES_BY_DOMAINE_FAIL,
    CREATE_DOMAINE_REQUEST, CREATE_DOMAINE_SUCCESS, CREATE_DOMAINE_FAIL,
    UPDATE_DOMAINE_REQUEST, UPDATE_DOMAINE_SUCCESS, UPDATE_DOMAINE_FAIL,
    DELETE_DOMAINE_REQUEST, DELETE_DOMAINE_SUCCESS, DELETE_DOMAINE_FAIL,
    CREATE_THEME_REQUEST, CREATE_THEME_SUCCESS, CREATE_THEME_FAIL,
    UPDATE_THEME_REQUEST, UPDATE_THEME_SUCCESS, UPDATE_THEME_FAIL,
    DELETE_THEME_REQUEST, DELETE_THEME_SUCCESS, DELETE_THEME_FAIL,
    SET_PARAM_DOMAINES_THEMES_LOADING, CLEAR_PARAM_DOMAINES_THEMES_ERROR,
    DOWNLOAD_DOMAINES_TEMPLATE_REQUEST,
    DOWNLOAD_DOMAINES_TEMPLATE_SUCCESS,
    DOWNLOAD_DOMAINES_TEMPLATE_FAIL,
    DOWNLOAD_THEMES_TEMPLATE_REQUEST,
    DOWNLOAD_THEMES_TEMPLATE_SUCCESS,
    DOWNLOAD_THEMES_TEMPLATE_FAIL,
    IMPORT_DOMAINES_EXCEL_REQUEST,
    IMPORT_DOMAINES_EXCEL_SUCCESS,
    IMPORT_DOMAINES_EXCEL_FAIL,
    IMPORT_THEMES_EXCEL_REQUEST,
    IMPORT_THEMES_EXCEL_SUCCESS,
    IMPORT_THEMES_EXCEL_FAIL,
    CLEAR_BULK_REVIEW,
} from "../actions/paramDomainesThemesActions";

const initialState = {
    domaines: [],
    themes: [],
    themesFiltered: null, // si filtre par domaine
    loading: false,
    error: null,
    bulkLoading: false,
    bulkResult: null,
    bulkError: null,
};

export default function paramDomainesThemesReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PARAM_DOMAINES_THEMES_LOADING:
            return { ...state, loading: action.payload };

        case CLEAR_PARAM_DOMAINES_THEMES_ERROR:
            return { ...state, error: null };

        // Domaines
        case FETCH_DOMAINES_REQUEST:
        case CREATE_DOMAINE_REQUEST:
        case UPDATE_DOMAINE_REQUEST:
        case DELETE_DOMAINE_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_DOMAINES_SUCCESS:
            return { ...state, loading: false, domaines: action.payload || [] };

        case CREATE_DOMAINE_SUCCESS:
            return { ...state, loading: false, domaines: [...state.domaines, action.payload] };

        case UPDATE_DOMAINE_SUCCESS:
            return {
                ...state,
                loading: false,
                domaines: state.domaines.map((d) => (d.id === action.payload.id ? action.payload : d)),
            };

        case DELETE_DOMAINE_SUCCESS:
            return {
                ...state,
                loading: false,
                domaines: state.domaines.filter((d) => d.id !== action.payload.id),
            };

        case FETCH_DOMAINES_FAIL:
        case CREATE_DOMAINE_FAIL:
        case UPDATE_DOMAINE_FAIL:
        case DELETE_DOMAINE_FAIL:
            return { ...state, loading: false, error: action.error || "Erreur" };

        // Themes
        case FETCH_THEMES_REQUEST:
        case FETCH_THEMES_BY_DOMAINE_REQUEST:
        case CREATE_THEME_REQUEST:
        case UPDATE_THEME_REQUEST:
        case DELETE_THEME_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_THEMES_SUCCESS:
            return { ...state, loading: false, themes: action.payload || [], themesFiltered: null };

        case FETCH_THEMES_BY_DOMAINE_SUCCESS:
            return { ...state, loading: false, themesFiltered: action.payload || [] };

        case CREATE_THEME_SUCCESS:
            return {
                ...state,
                loading: false,
                themes: [...state.themes, action.payload],
                themesFiltered: state.themesFiltered ? [...state.themesFiltered, action.payload] : state.themesFiltered,
            };

        case UPDATE_THEME_SUCCESS:
            return {
                ...state,
                loading: false,
                themes: state.themes.map((t) => (t.id === action.payload.id ? action.payload : t)),
                themesFiltered: state.themesFiltered
                    ? state.themesFiltered.map((t) => (t.id === action.payload.id ? action.payload : t))
                    : state.themesFiltered,
            };

        case DELETE_THEME_SUCCESS:
            return {
                ...state,
                loading: false,
                themes: state.themes.filter((t) => t.id !== action.payload.id),
                themesFiltered: state.themesFiltered ? state.themesFiltered.filter((t) => t.id !== action.payload.id) : null,
            };

        case FETCH_THEMES_FAIL:
        case FETCH_THEMES_BY_DOMAINE_FAIL:
        case CREATE_THEME_FAIL:
        case UPDATE_THEME_FAIL:
        case DELETE_THEME_FAIL:
            return { ...state, loading: false, error: action.error || "Erreur" };

        case DOWNLOAD_DOMAINES_TEMPLATE_REQUEST:
        case DOWNLOAD_THEMES_TEMPLATE_REQUEST:
        case IMPORT_DOMAINES_EXCEL_REQUEST:
        case IMPORT_THEMES_EXCEL_REQUEST:
            return {
                ...state,
                bulkLoading: true,
                bulkError: null,
            };

        case DOWNLOAD_DOMAINES_TEMPLATE_SUCCESS:
        case DOWNLOAD_THEMES_TEMPLATE_SUCCESS:
            return {
                ...state,
                bulkLoading: false,
            };

        case IMPORT_DOMAINES_EXCEL_SUCCESS:
        case IMPORT_THEMES_EXCEL_SUCCESS:
            return {
                ...state,
                bulkLoading: false,
                bulkResult: action.payload, // ✅ review stocké ici
            };

        case DOWNLOAD_DOMAINES_TEMPLATE_FAIL:
        case DOWNLOAD_THEMES_TEMPLATE_FAIL:
        case IMPORT_DOMAINES_EXCEL_FAIL:
        case IMPORT_THEMES_EXCEL_FAIL:
            return {
                ...state,
                bulkLoading: false,
                bulkError: action.payload,
            };

        case CLEAR_BULK_REVIEW:
            return {
                ...state,
                bulkResult: null,
                bulkError: null,
            };

        default:
            return state;
    }
}
